import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'saved-items',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/SavedItemsAuthenticated'),
  }),
};
